export { default as RatesService } from './Rates';
